const NavBar = {
    init: ($) => {
        //toggle
        $('.navbar-toggle').on('click', function() {
            $(this).toggleClass('open');
            $('#navigation').slideToggle(400);
        });

        $('.navigation-menu>li').slice(-1).addClass('last-elements');
        $('a.menu-my-profile').parent('li').addClass('d-none d-lg-block');

        $('.navigation-menu li.has-submenu a[href="#"]').on('click', function(e) {
            if ($(window).width() < 992) {
                e.preventDefault();
                $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
            }
        });

        $('.right-bar-toggle').click(function() {
            $('.right-bar').toggle();
            $('.wrapper').toggleClass('right-bar-enabled');
        });
    },
};

// === following js will activate the menu in left side bar based on url ====
$(document).ready(function () {
    $('.navigation-menu a').each(function () {
        if (this.pathname === window.location.pathname && $(this).attr('href') !== '#') { //this is to make sure that the resources tab on the top navbar doesn't also become active
            $(this).parent().addClass('active'); // add active to li of the current link
            $(this).parent().parent().parent().addClass('active'); // add active class to an anchor
            $(this).parent().parent().parent().parent().parent().addClass('active'); // add active class to an anchor
        }
    });
});

export default NavBar;
